module.exports = require('./fetch')



//////////////////
// WEBPACK FOOTER
// ./src/mock/fetch/index.js
// module id = 29
// module chunks = 0